import React from 'react'
import { useEffect, useRef, useState } from 'react'
import { gantChart } from "./anychartGantt";
import { tokens } from "../../../assets/theme";
import { useTheme, FormControlLabel, Switch, alpha, Tooltip, Chip, Typography, FormControl, InputLabel, FormLabel } from '@mui/material';
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { Button, IconButton, Box, Stack } from "@mui/material";

import AxionControls from "../../../components/controls/AxionControls";

import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import ExpandOutlinedIcon from '@mui/icons-material/ExpandOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FormattedMessage, useIntl } from "react-intl";
import messages from "../messages";
import RestoreIcon from '@mui/icons-material/Restore';
import useFeatureFlags, { isFeatureEnabled } from "../../../hooks/useFeatureFlags";


function Gantt(props) {
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
    const [ganttDarkMode, setGanttDarkMode] = useLocalStorage("ganttDarkMode", "true");
    const chartContainerRef = useRef(null);
    const containerId = "chart_container";
    const chart = useRef(null);
    // const [runningFilter, setRunningFilter] = useLocalStorage("ProdPlanRunningFilter", false);
    // const [calculatedEndFilter, setCalculatedEndFilter] = useLocalStorage("ProdPlanCalculatedEndFilter", false);
    // const [showReplanned, setShowReplanned] = useLocalStorage("ProdPlanShowReplanned", false);
    // const [showMain, setShowMain] = useLocalStorage("ProdPlanShowMain", true);
    // const [showCalendar, setShowCalendar] = useLocalStorage("ProdPlanShowCalendar", false);

    const [confirmationTitle, setConfirmationTitle] = useState("");
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [openConfirmationSaveAll, setOpenConfirmationSaveAll] = useState(false);
    const [openConfirmationCancelAll, setOpenConfirmationCancelAll] = useState(false);
    const [openConfirmationSaveMarkedRows, setOpenConfirmationSaveMarkedRows] = useState(false);
    const [openConfirmationSaveMachine, setOpenConfirmationSaveMachine] = useState(false);
    const [openConfirmationCancelMachine, setOpenConfirmationCancelMachine] = useState(false);

    const [saveMachineId, setSaveMachineId] = useState(null);
    const [cancelMachineId, setCancelMachineId] = useState(null);

    let startDate = props.startDate ? new Date(props.startDate) : new Date();
    let endDate = props.endDate ? new Date(props.endDate) : new Date();
    let buttonDisabled = props.disableSaveButton;

    useEffect(() => {
        chartContainerRef.current.style.touchAction = 'pan-x pan-y';
    }, []);

    useEffect(() => {
        if (props.zoomToDates && props.zoomToDates.min && props.zoomToDates.max && chart && chart.current) {
            //console.log("Gantt zoomToDates changed, zooming to:", props.zoomToDates.min, props.zoomToDates.max);
            chart.current.zoomTo(new Date(props.zoomToDates.min), new Date(props.zoomToDates.max));
        }
    }, [props.zoomToDates]);

    //let chart = null

    useEffect(() => {
        chart.current = gantChart(containerId, props.data, props.handleClick, colors, startDate, endDate, companyKey, ganttDarkMode, props.company, props.featureFlags, props.handleUpdateData, props.timeSpan, props.handleOpenNewPO, props.edit, props.handleCheckboxClick, props.markedForUpdate, handleCancelMachineClick, props.zoomLevel, props.setZoomLevel, props.defaultOee, props.showBlockValue, handleSaveMachineClick); //redrawChart

        return () => {
            //Preventing duplicate renders
            chart.current.dispose();
        }
    }, [props.startDate, props.endDate, props.data, props.edit, props.snapToPrevious, props.replanOverlaps, props.recalculateAffectedOrders]);

    function getDateWithDayOffset(offset) {
        var newDate = new Date();
        newDate.setDate(newDate.getDate() + offset);
        newDate.setHours(0, 0, 0, 0)
        return newDate;//.toISOString();//.replace("T", " ").replace("Z", ""); // Return date in YYYY-MM-DD format
    }

    // Set zoom level
    function handleZoomIn() {
        if (chart === null || chart === undefined) {
            // alert("Chart is missing?");
        } else {
            //chart.current.zoomIn(2);
            chart.current.zoomIn(2);
        }
        //console.log("Zoomed in", chart.current.getTimeline().scale().minimum(), "to", chart.current.getTimeline().scale().maximum());
        //console.log ("Zoomed in level",chart.current.getTimeline().zoomLevel());
        const { min, max } = chart.current.getTimeline().scale().getRange();

        props.setZoomLevel({ min: min, max: max })
        //console.log("Scale min/max", min, max);
        //console.log ("Setting zoom level to", chart.current.getTimeline().zoomLevel());
    }

    function handleZoomOut() {
        if (chart === null || chart === undefined) {
            // alert("Chart is missing?");
        } else {
            chart.current.zoomOut(2);
        }
        const { min, max } = chart.current.getTimeline().scale().getRange();

        props.setZoomLevel({ min: min, max: max })

        //console.log("Zoomed out", chart.current.getTimeline().scale().minimum(), "to", chart.current.getTimeline().scale().maximum());

    }

    function handleZoomToNow() {
        //console.log ("Zooming ou", containerId.current, chart);
        let today = new Date();
        let todayYear = today.getFullYear();
        let todayMonth = today.getMonth();
        let TodayDay = today.getDate();

        let tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);

        let tomorrowYear = tomorrow.getFullYear();
        let tomorrowMonth = tomorrow.getMonth();
        let tomorrowDay = tomorrow.getDate();

        //console.log("Zooming to now", todayYear, todayMonth, TodayDay, tomorrowYear, tomorrowMonth, tomorrowDay);

        //chart.zoomTo(new Date(todayYear, todayMonth, TodayDay), new Date(tomorrowYear, tomorrowMonth, tomorrowDay));
        //chart.zoomTo(new Date(2025, 4, 22), new Date(2025, 4, 23));
        //console.log("Zooming to now", chart, getDateWithDayOffset(-1), getDateWithDayOffset(2));

        if (chart === null || chart === undefined) {
            //alert("Chart is missing?");
            //initChart();
            //chart.zoomTo(getDateWithDayOffset(-1), getDateWithDayOffset(2));
            //setTimeout(() => {chart.zoomTo(getDateWithDayOffset(-1), getDateWithDayOffset(2));}, 1000);
        } else {
            chart.current.zoomTo(getDateWithDayOffset(-3), getDateWithDayOffset(4));
            const { min, max } = chart.current.getTimeline().scale().getRange();

            props.setZoomLevel({ min: min, max: max })
        }
    }

    function handleZoomToAll() {
        //console.log ("Zooming to all", containerId.current, chart);
        if (chart === null || chart === undefined) {
            //alert("Chart is missing?");
        } else {
            chart.current.fitAll();
        }
    };

    // zoom the timeline to the given units
    function zoomToUnits() {
        var unit = document.getElementById("unitSelect").value;
        var count = document.getElementById("countInput").value;
        var anchor = document.getElementById("anchorSelect").value;
        //console.log("Zooming to units", unit, count, anchor);
        //chart.zoomTo(unit, count, anchor);
    }

    const handleSaveAllClick = () => {
        buttonDisabled = true;
        setOpenConfirmationSaveAll(false);
        //console.log("Save all clicked", props.disableSaveButton);
        props.setDisableSaveButton(true);
        props.handleSaveAll(() => {
            //props.setDisableSaveButton(false);
        });
    }
    const handleCancelSaveAll = () => {
        setOpenConfirmationSaveAll(false);
    }
    const handleCancelSaveAllClick = () => {
        setOpenConfirmationCancelAll(false);
        props.handleCancelSaveAll(() => {
            //props.setDisableSaveButton(false);
        });
    }
    const handleCancelCancelAll = () => {
        setOpenConfirmationCancelAll(false);
    }

    const handleSaveMarkedRowsClick = () => {
        setOpenConfirmationSaveMarkedRows(false);
        props.handleSaveMarkedRows(() => {
            //props.setDisableSaveButton(false);
        });
    }
    const handleCancelSaveMarkedRows = () => {
        setOpenConfirmationSaveMarkedRows(false);
    }



    const handleSaveMachineClick = (machineId) => {
        console.log("Save machine clicked for machine ID: " + machineId);
        setOpenConfirmationSaveMachine(true);
        setConfirmationTitle(formatMessage(messages.saveMachineConfirmationTitle));
        setConfirmationMessage(formatMessage(messages.saveMachineConfirmationMessage));
        setSaveMachineId(machineId);
    }
    const handleSaveMachineCancelClick = () => {
        console.log("Cancelled save for machine ID: " + saveMachineId);
        setOpenConfirmationSaveMachine(false);
    }
    const handleSaveMachineOkClick = () => {
        console.log("Confirmed save for machine ID: " + saveMachineId);
        setOpenConfirmationSaveMachine(false);
        props.handleRowSaveClick(saveMachineId);
    }
        

    const handleCancelMachineClick = (machineId) => {
        console.log("Cancel machine clicked for machine ID: " + machineId);
        setOpenConfirmationCancelMachine(true);
        setConfirmationTitle(formatMessage(messages.cancelMachineConfirmationTitle));
        setConfirmationMessage(formatMessage(messages.cancelMachineConfirmationMessage));
        setCancelMachineId(machineId);
    }

    const handleCancelMachineCancelClick = () => {
        console.log("Cancelled cancel for machine ID: " + cancelMachineId);
        setOpenConfirmationCancelMachine(false);
    }
    const handleCancelMachineOkClick = () => {
        console.log("Confirmed cancel for machine ID: " + cancelMachineId);
        setOpenConfirmationCancelMachine(false);
        props.handleRowUndoClick(cancelMachineId);
    }




    // const handleCheckboxClick = (machineId, checked) => {
    //     //alert("Checkbox clicked for machine ID: " + machineId + ", checked: " + checked);
    //     props.handleCheckboxClick(machineId, checked);
    // }

    //console.log("gantt.runningfilter", runningFilter);

    //console.log("props.data", props.data);



    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <Stack direction="row" spacing={1} sx={{ backgroundColor: colors.primary[400], paddingLeft: "10px", marginLeft: "1px", marginRight: "1px", display: "flex", alignItems: "center", height: "70px", flexShrink: 0 }}>
                {/* <Box sx={{ width: "190px" }}></Box> */}
                <FormControl component="fieldset">
                    <Box sx={{ marginBottom: "-8px", marginLeft: "10px", paddingLeft: "4px", textAlign: "center", fontSize: "0.65rem", backgroundColor: colors.primary[400], color: colors.primary[100], width: "90px", zIndex: 100 }}><FormattedMessage {...messages.manipulateChart} /></Box>

                    <Stack direction="row" spacing={0} sx={{ border: "1px solid", borderColor: colors.primary[300], borderRadius: "5px", padding: "5px", zIndex: 1 }}  >



                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.zoomIn)}</Typography>} arrow>
                            <IconButton id="zoomIn" onClick={handleZoomIn} sx={{ color: colors.primary[100] }}>
                                <AddCircleOutlineOutlinedIcon />
                                {/* <ZoomInOutlinedIcon /> */}
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.zoomOut)}</Typography>} arrow>
                            <IconButton id="zoomOut" onClick={handleZoomOut} sx={{ color: colors.primary[100] }}>
                                <RemoveCircleOutlineOutlinedIcon />
                                {/* <ZoomOutOutlinedIcon /> */}
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.zoomToNow)}</Typography>} arrow>
                            <IconButton id="zoomToNow" onClick={handleZoomToNow} sx={{ color: colors.primary[100] }}>
                                <VerticalAlignCenterIcon style={{ transform: 'rotate(90deg)' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.zoomToFullInterval)}</Typography>} arrow>
                            <IconButton id="zoomToUnitsButton" onClick={handleZoomToAll} sx={{ color: colors.primary[100] }}>
                                <ExpandOutlinedIcon style={{ transform: 'rotate(90deg)' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={
                            <Typography fontSize="12px">
                                {/* Legend for colors and symbols: */}
                                <table>
                                    <tr>
                                        <td style={{ paddingTop: "5px" }} colSpan={2}><b><FormattedMessage {...messages.legendLegend} /></b></td>
                                        {/* <td></td> */}
                                    </tr>
                                    <tr>
                                        <td><Box sx={{ width: "15px", height: "15px", backgroundColor: "#799c4a", borderRadius: "2px", marginRight: "7px" }} ></Box> </td>
                                        <td><FormattedMessage {...messages.legendRunning} /></td>
                                    </tr>
                                    <tr>
                                        <td><Box sx={{ width: "15px", height: "15px", backgroundColor: "#db4f4a", borderRadius: "2px", marginRight: "7px" }} ></Box> </td>
                                        <td><FormattedMessage {...messages.legendBehindSchedule} /></td>
                                    </tr>
                                    <tr>
                                        <td ><Box sx={{ width: "15px", height: "15px", backgroundColor: "#86a8e2ff", borderRadius: "2px", marginRight: "7px" }} ></Box> </td>
                                        <td><FormattedMessage {...messages.legendPlanned} /></td>
                                    </tr>
                                    <tr>
                                        <td ><Box sx={{ width: "15px", height: "15px", backgroundColor: "#aaaaaa", borderRadius: "2px", marginRight: "7px" }} ></Box> </td>
                                        <td><FormattedMessage {...messages.legendFinished} /></td>
                                    </tr>
                                    <tr>
                                        <td ><Box sx={{ width: "15px", height: "15px", backgroundColor: "#213046ff", borderRadius: "2px", marginRight: "7px" }} ></Box> </td>
                                        <td><FormattedMessage {...messages.legendNotSaved} /></td>
                                    </tr>



                                    <tr>
                                        <td style={{ paddingTop: "20px" }} colSpan={2}><b><FormattedMessage {...messages.legendSymbols} /></b></td>
                                        {/* <td></td> */}
                                    </tr>
                                    <tr>
                                        <td style={{ width: "20px" }}><b>►</b></td>
                                        <td><FormattedMessage {...messages.legendRunning} /></td>
                                    </tr>
                                    {/* <tr>
                                <td style={{ width: "20px" }}><b>P</b></td>
                                <td><FormattedMessage {...messages.legendPlanned} /></td>
                            </tr> */}
                                    <tr>
                                        <td style={{ width: "20px" }}><b>▼</b></td>
                                        <td><FormattedMessage {...messages.legendReportedQty} /></td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: "20px" }}><b>✔</b></td>
                                        <td><FormattedMessage {...messages.legendFinished} /></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "20px" }}><b>◙</b></td>
                                        <td><FormattedMessage {...messages.legendBlocker} /></td>
                                    </tr>




                                </table>

                            </Typography>} arrow>
                            <IconButton id="zoomToUnitsButton" onClick={handleZoomToAll} sx={{ color: colors.primary[100] }}>
                                <InfoOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </FormControl>
                {/* <Box sx={{ width: '5px' }}> </Box> */}


                <FormControl component="fieldset">

                    <Box sx={{ marginBottom: "-8px", marginLeft: "10px", paddingLeft: "4px", textAlign: "center", fontSize: "0.65rem", backgroundColor: colors.primary[400], color: colors.primary[100], width: "130px", zIndex: 100 }}><FormattedMessage {...messages.showDataInChart} /></Box>

                    <Stack direction="row" spacing={0} sx={{ border: "1px solid", borderColor: colors.primary[300], borderRadius: "5px", padding: "5px", zIndex: 1 }}  >
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.showOriginalTooltip)}</Typography>} arrow>
                            <Button onClick={(event, newValue) => { props.handleShowMain(event, newValue); }}>
                                <Chip label={formatMessage(messages.showOriginalSwitch)} size="small" sx={{ backgroundColor: props.showMain ? "#799c4a" : "default", color: props.showMain ? "#ffffff" : "#000000", width: "130px" }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.showUnsavedTooltip)}</Typography>} arrow>
                            <Button onClick={(event, newValue) => { props.handleShowUnsaved(event, newValue); }}>
                                <Chip label={formatMessage(messages.showUnsavedSwitch)} size="small" sx={{ backgroundColor: props.showUnsaved ? "#799c4a" : "default", color: props.showUnsaved ? "#ffffff" : "#000000", width: "130px" }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.onlyRunningTooltip)}</Typography>} arrow>
                            <Button onClick={(event, newValue) => { props.handleRunningFilter(event, newValue); }}>
                                <Chip label={formatMessage(messages.onlyRunningSwitch)} size="small" sx={{ backgroundColor: props.runningFilter ? "#799c4a" : "default", color: props.runningFilter ? "#ffffff" : "#000000", width: "130px" }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.showCalcEndTooltip)}</Typography>} arrow>
                            <Button onClick={(event, newValue) => { props.handleCalculatedEndFilter(event, newValue); }}>
                                <Chip label={formatMessage(messages.showCalcEndSwitch)} size="small" sx={{ backgroundColor: props.calculatedEndFilter ? "#799c4a" : "default", color: props.calculatedEndFilter ? "#ffffff" : "#000000", width: "130px" }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.suggestPlanningTooltip)}</Typography>} arrow>
                            <Button onClick={(event, newValue) => { props.handleShowReplanned(event, newValue); }}>
                                <Chip label={formatMessage(messages.suggestPlanningSwitch)} size="small" sx={{ backgroundColor: props.showReplanned ? "#799c4a" : "default", color: props.showReplanned ? "#ffffff" : "#000000", width: "130px" }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={<Typography fontSize="12px">{formatMessage(messages.showCalendarTooltip)}</Typography>} arrow>
                            <Button onClick={(event, newValue) => { props.handleShowCalendar(event, newValue); }}>
                                <Chip label={formatMessage(messages.showCalendarSwitch)} size="small" sx={{ backgroundColor: props.showCalendar ? "#799c4a" : "default", color: props.showCalendar ? "#ffffff" : "#000000", width: "130px" }} />
                            </Button>
                        </Tooltip>
                    </Stack>
                </FormControl>



                {/* 
                <FormControlLabel
                    sx={{
                        marginLeft: '15px',
                        width: '150px'
                    }}
                    control={
                        <Switch
                            defaultChecked={props.runningFilter}
                            sx={{

                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: "#799c4a !important",
                                    '&:hover': {
                                        backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                    },
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: "#799c4a !important",
                                },
                            }}
                            onChange={(event, newValue) => {
                                props.handleRunningFilter(event, newValue);
                            }}
                            name="running"
                        />
                    }
                    label={formatMessage(messages.onlyRunningSwitch)}
                /> */}
                {/* <Box sx={{ width: '20px' }}> </Box>  */}
                {/* <FormControlLabel
                    sx={{
                        marginLeft: '1px',
                        minWidth: '170px',
                    }}
                    control={
                        <Switch
                            defaultChecked={props.calculatedEndFilter}
                            sx={{

                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: "#799c4a !important",
                                    '&:hover': {
                                        backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                    },
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: "#799c4a !important",
                                },
                            }}
                            onChange={(event, newValue) => {
                                props.handleCalculatedEndFilter(event, newValue);
                            }}
                            name="calculatedEndFilter"
                        />
                    }
                    label={formatMessage(messages.showCalcEndSwitch)} // {<FormattedMessage {...messages.onlyRunningFilter} />}
                /> */}
                {/* <FormControlLabel
                    sx={{
                        marginLeft: '1px',
                        width: '170px',
                    }}
                    control={
                        <Switch
                            defaultChecked={props.showReplanned}
                            sx={{

                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: "#799c4a !important",
                                    '&:hover': {
                                        backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                    },
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: "#799c4a !important",
                                },
                            }}
                            onChange={(event, newValue) => {
                                props.handleShowReplanned(event, newValue);
                            }}
                            name="showReplannedFilter"
                        />
                    }
                    label={formatMessage(messages.suggestPlanningSwitch)}
                /> */}
                {/* <FormControlLabel
                    sx={{
                        marginLeft: '1px',
                        width: '150px',
                    }}
                    control={
                        <Switch
                            defaultChecked={props.showMain}
                            sx={{

                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: "#799c4a !important",
                                    '&:hover': {
                                        backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                    },
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: "#799c4a !important",
                                },
                            }}
                            onChange={(event, newValue) => {
                                props.handleShowMain(event, newValue);
                            }}
                            name="showMainFilter"
                        />
                    }
                    label={formatMessage(messages.showOriginalSwitch)}
                /> */}

                {/* <FormControlLabel
                    sx={{
                        marginLeft: '1px',
                        width: '150px',
                    }}
                    control={
                        <Switch
                            defaultChecked={props.showCalendar}
                            sx={{

                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: "#799c4a !important",
                                    '&:hover': {
                                        backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                    },
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: "#799c4a !important",
                                },
                            }}
                            onChange={(event, newValue) => {
                                props.handleShowCalendar(event, newValue);
                            }}
                            name="showCalendarFilter"
                        />
                    }
                    label={formatMessage(messages.showCalendarSwitch)}
                /> */}

                <Box sx={{ flexGrow: 1 }} />
                <Stack direction="row" sx={{ marginLeft: '20px' }} spacing={0} >

                    {isFeatureEnabled(props.featuresQuery, "ProductionPlanningEdit") &&
                        <Tooltip title={<Typography fontSize="12px">Planera utan att ändringarna sparas direkt. Välj sedan att avbryta eller spara gjorda förändringar</Typography>} size="medium" arrow>
                            <Button onClick={() => {
                                if (props.edit === "true") {
                                    props.setEdit("false");
                                } else {
                                    props.setEdit("true");
                                }
                            }}>
                                <Chip label={formatMessage(messages.editButton)} size="small" sx={{ backgroundColor: props.edit === "true" ? colors.redAccent[500] : "default", color: props.edit === "true" ? "#ffffff" : "#000000", width: "80px" }} />
                            </Button>
                        </Tooltip>
                    }
                </Stack>
            </Stack>

            <Stack direction="row" spacing={1} sx={{ backgroundColor: colors.primary[400], marginTop: "1px", paddingTop: "10px", paddingLeft: "10px", marginLeft: "1px", marginRight: "1px", paddingBottom: "10px", paddingRight: "10px", display: "flex", alignItems: "center", flexShrink: 0 }}>
                {props.showReplanned && props.edit === "true" &&
                    <>
                        <Box width="20px"></Box>
                        <Button
                            disabled={buttonDisabled}
                            variant="contained"
                            sx={{
                                marginTop: 2,
                                marginLeft: "auto",
                                display: "block",
                                width: "130px",
                            }}
                            //onClick={handleSaveMarkedRowsClick}>
                            onClick={() => {
                                setConfirmationTitle(formatMessage(messages.saveMarkedRowsConfirmationTitle));
                                setConfirmationMessage(formatMessage(messages.saveMarkedRowsConfirmationMessage));
                                setOpenConfirmationSaveMarkedRows(true)
                            }
                            }>
                            <FormattedMessage {...messages.updateRowsButton} />
                        </Button>
                        <Box width="32px"></Box>
                    </>
                }
                {(props.edit !== "true" || !props.showReplanned) &&
                    <Box width="198px"></Box>
                }

                {/* <Box sx={{ height: "55px", width: "2px", backgroundColor: "#CECECE" }}>&nbsp;</Box> */}

                <FormControl component="fieldset">

                    <Box sx={{ marginBottom: "-8px", marginLeft: "10px", paddingLeft: "4px", textAlign: "center", fontSize: "0.65rem", backgroundColor: colors.primary[400], color: colors.primary[100], width: "90px", zIndex: 100 }}><FormattedMessage {...messages.showBlockLabel} /></Box>

                    <Stack direction="row" spacing={0} sx={{ border: "1px solid", borderColor: colors.primary[300], borderRadius: "5px", padding: "5px", zIndex: 1 }} display="flex" alignItems="center" >

                        <Button labelId="block-label-label" onClick={() => props.handleSetShowBlockValue("PO")}>
                            <Chip label={formatMessage(messages.labelPo)} size="small" sx={{ backgroundColor: props.showBlockValue === "PO" ? "#799c4a" : "default", color: props.showBlockValue === "PO" ? "#ffffff" : "#000000", width: "60px" }} />
                        </Button>
                        <img src="/assets/dot_lightgray.png" width="8px" height="1px" alt=""></img>
                        <Button onClick={() => props.handleSetShowBlockValue("Tool")}>
                            <Chip label={formatMessage(messages.labelTool)} size="small" sx={{ backgroundColor: props.showBlockValue === "Tool" ? "#799c4a" : "default", color: props.showBlockValue === "Tool" ? "#ffffff" : "#000000", width: "60px" }} />
                        </Button>
                        <img src="/assets/dot_lightgray.png" width="8px" height="1px" alt=""></img>
                        <Button onClick={() => props.handleSetShowBlockValue("Item")}>
                            <Chip label={formatMessage(messages.labelArticle)} size="small" sx={{ backgroundColor: props.showBlockValue === "Item" ? "#799c4a" : "default", color: props.showBlockValue === "Item" ? "#ffffff" : "#000000", width: "60px" }} />
                        </Button>
                    </Stack>

                </FormControl>

                {(props.edit === "true") &&
                    <FormControl component="fieldset">

                        <Box sx={{ marginBottom: "-8px", marginLeft: "10px", paddingLeft: "4px", textAlign: "center", fontSize: "0.65rem", backgroundColor: colors.primary[400], color: colors.primary[100], width: "110px", zIndex: 100 }}><FormattedMessage {...messages.rearrangeFunctions} /></Box>

                        <Stack direction="row" spacing={0} sx={{ border: "1px solid", borderColor: colors.primary[300], borderRadius: "5px", padding: "5px", zIndex: 1 }}  >
                            <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.snappingButtonInfo} /></Typography>} size="medium" arrow>
                                <Button onClick={() => {
                                    if (props.snapToPrevious === "true") {
                                        props.setSnapToPrevious("false");
                                    } else {
                                        props.setSnapToPrevious("true");
                                    }
                                }}>
                                    <Chip label={formatMessage(messages.snappingButton)} size="small" sx={{ backgroundColor: props.snapToPrevious === "true" ? "#799c4a" : "default", color: props.snapToPrevious === "true" ? "#ffffff" : "#000000", width: "80px" }} />
                                </Button>
                            </Tooltip>
                            <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.rearrangeButtonInfo} /></Typography>} arrow>
                                <Button onClick={() => {
                                    if (props.replanOverlaps === "true") {
                                        props.setReplanOverlaps("false");
                                    } else {
                                        props.setReplanOverlaps("true");
                                    }
                                }}>
                                    <Chip label={formatMessage(messages.rearrangeButton)} size="small" sx={{ backgroundColor: props.replanOverlaps === "true" ? "#799c4a" : "default", color: props.replanOverlaps === "true" ? "#ffffff" : "#000000", width: "80px" }} />
                                </Button>
                            </Tooltip>


                            {/* <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.recalculateButtonInfo} /></Typography>} arrow>
                        <Button onClick={() => {
                            if (props.recalculateAffectedOrders === "true") {
                                props.setRecalculateAffectedOrders("false");
                            } else {
                                props.setRecalculateAffectedOrders("true");
                            }
                        }}>
                            <Chip label={formatMessage(messages.recalculateButton)} size="small" sx={{ backgroundColor: props.recalculateAffectedOrders === "true" ? "#799c4a" : "default", color: props.recalculateAffectedOrders === "true" ? "#ffffff" : "#000000", width: "80px" }} />
                        </Button>
                    </Tooltip> */}
                        </Stack>
                    </FormControl>
                }
                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ width: "80px" }}></Box>
                {(props.edit === "true") &&
                    <>
                        <Button
                            //disabled={buttonDisabled}
                            variant="contained"
                            sx={{
                                marginTop: 2,
                                marginLeft: "auto",
                                display: "block",
                                width: "100px",
                            }}
                            // onClick={handleCancelSaveAllClick}>
                            onClick={() => {
                                setConfirmationTitle(formatMessage(messages.cancelAllConfirmationTitle));
                                setConfirmationMessage(formatMessage(messages.cancelAllConfirmationMessage));
                                setOpenConfirmationCancelAll(true)

                            }}>
                            <FormattedMessage {...messages.cancelAllButton} />
                        </Button>
                        <Button
                            disabled={buttonDisabled}
                            variant="contained"
                            sx={{
                                marginTop: 2,
                                marginLeft: "auto",
                                display: "block",
                                width: "100px",
                            }}
                            // onClick={handleSaveAllClick}>
                            onClick={() => {
                                setConfirmationTitle(formatMessage(messages.saveAllConfirmationTitle));
                                setConfirmationMessage(formatMessage(messages.saveAllConfirmationMessage));
                                setOpenConfirmationSaveAll(true);
                            }}>
                            <FormattedMessage {...messages.saveAllButton} />
                        </Button>
                    </>
                }



            </Stack>



            {/* <button id="zoomIn" onClick={handleZoomIn}>Zoom in</button>
            <button id="zoomOut" onClick={handleZoomOut}>Zoom out</button>
            <button id="zoomOut" onClick={handleZoomToNow}>Zoom now</button>
            <button id="zoomOut" onClick={fitAll}>Zoom to all</button> */}
            {/* <button id="zoomToUnitsButton" onClick={zoomToUnits}>Zoom To Units</button>
            <label for="unitSelect">unit: </label>
            <select id="unitSelect">
                <option value="millisecond">millisecond</option>
                <option value="second">second</option>
                <option value="minute">minute</option>
                <option value="hour">hour</option>
                <option value="day">day</option>
                <option value="week" selected>week</option>
                <option value="third-of-month">third-of-month</option>
                <option value="month">month</option>
                <option value="quarter">quarter</option>
                <option value="semester">semester</option>
                <option value="year">year</option></select>
            <label>count: <input id="countInput" value="10" /></label>
            <label for="anchorSelect">anchor: </label>
            <select id="anchorSelect">
                <option value="first-date" selected>first-date</option>
                <option value="first-visible-date">first-visible-date</option>
                <option value="last-date">last-date</option>
                <option value="last-visible-date">last-visible-date</option>
            </select> */}
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <div id={containerId} ref={chartContainerRef} style={{ width: "100%", height: "100%" }}></div>
            </Box>
            <AxionControls.AxionConfirmation open={openConfirmationSaveAll} title={confirmationTitle} message={confirmationMessage} onConfirm={handleSaveAllClick} onCancel={handleCancelSaveAll} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
            <AxionControls.AxionConfirmation open={openConfirmationCancelAll} title={confirmationTitle} message={confirmationMessage} onConfirm={handleCancelSaveAllClick} onCancel={handleCancelCancelAll} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
            <AxionControls.AxionConfirmation open={openConfirmationSaveMarkedRows} title={confirmationTitle} message={confirmationMessage} onConfirm={handleSaveMarkedRowsClick} onCancel={handleCancelSaveMarkedRows} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />

            <AxionControls.AxionConfirmation open={openConfirmationSaveMachine} title={confirmationTitle} message={confirmationMessage} onConfirm={handleSaveMachineOkClick} onCancel={handleSaveMachineCancelClick} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
            <AxionControls.AxionConfirmation open={openConfirmationCancelMachine} title={confirmationTitle} message={confirmationMessage} onConfirm={handleCancelMachineOkClick} onCancel={handleCancelMachineCancelClick} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
        </Box>
    )
}

export default Gantt